<mat-icon style="width: 35px !important; padding: 0px;" class="component-svg-icon" svgIcon="bx-info-blue"
  title="{{ 'guide-map.label' | translate }}" clickable="true" (click)="openModal()"></mat-icon>